import { Service } from "onearm";

export class PaysTableService extends Service {
    constructor(parameters) {
        super(parameters);

        this.gameMath = parameters.services.get("gameMath");
        this.currenyFormatter = parameters.services.get("currencyFormatter");
        this.api = parameters.services.get("api");
    }

    async getPayTables() {
        const paytables = await this.api.getPayTable();

        const { regular, scatter } = paytables;

        return {
            paytables: this.getPayTabelsData(regular),
            scatter: this.getPayTabelsData(scatter),
            rtp: "96.50%", // TODO: get from config
            minBet: 1, // TODO: get from config
            maxBet: 100, // TODO: get from config
        };
    }

    getPayTabelsData(paytables) {
        const data = {};

        for (let i = 0; i < paytables.length; i++) {
            const { id, price, name } = paytables[i];

            data[this.gameMath.symbolIdToName(id)] = {
                ...this.priceToPaysTable(price),
                alias: name,
            };
        }

        return data;
    }

    priceToPaysTable(prices) {
        const payoutRanges = {};

        prices.forEach((price, index) => {
            if (price > 0) {
                const symbolsCount = index + 1;

                if (!payoutRanges[price]) {
                    payoutRanges[price] = {
                        min: symbolsCount,
                        max: symbolsCount,
                        payout: price,
                    };
                } else {
                    payoutRanges[price].min = Math.min(payoutRanges[price].min, symbolsCount);
                    payoutRanges[price].max = Math.max(payoutRanges[price].max, symbolsCount);
                }
            }
        });

        const list = Object.values(payoutRanges).sort((a, b) => a.payout - b.payout);
        const data = {};

        list.forEach(item => {
            data[`${item.min}-${item.max}`] = this.currenyFormatter.format(item.payout);
        });

        return data;
    }

    getScatterData(scatters) {
        const scatter = scatters[0];

        return {
            name: this.gameMath.symbolIdToName(scatter.id),
        };
    }
}
